export default __webpack_public_path__ + "icon-community.5664922b9e655f387ffdf19a39602888.svg";